'use es6';

import { handleActions } from 'flux-actions';
import * as ActionTypes from 'MeetingsAdmin/redux/actions/ActionTypes';
const initialState = '';
export default handleActions({
  [ActionTypes.BASE_URL_FETCH_SUCCEEDED](state, action) {
    return action.payload.urlInfo.baseUrl;
  }
}, initialState);